export const queryKey = {
  all: ['activity'] as const,
  byId: (activityInstanceId: number) =>
    [...queryKey.all, 'by-id', activityInstanceId] as const,
  insightsById: (activityInstanceId: number) =>
    [...queryKey.byId(activityInstanceId), 'insights'] as const,
  byRoomId: (roomId: number) =>
    [...queryKey.all, 'by-room-id', roomId] as const,
};
